import { LEVELS } from './constants'

// ─── Onboarding sample slots (V3-p) ───────────────────────────────────────────

export const POSITIONS = [0, 1, 2]

/**
 * `admin-onboarding_list`'s rows as a level → position → slot lookup. The
 * wire always sends nine; a slot it did not (it never happens, but a grid
 * with a hole would be worse than an empty cell) reads as empty.
 */
export function slotGrid(items) {
  const grid = {}
  for (const level of LEVELS) {
    grid[level] = {}
    for (const position of POSITIONS) grid[level][position] = { level, position, sample: null }
  }
  for (const slot of items) {
    if (grid[slot.level] && POSITIONS.includes(slot.position)) grid[slot.level][slot.position] = slot
  }
  return grid
}
